<template>
  <div class="divide-two">
    <div class="header" style="margin-top: .04rem;">
      <div>{{floorData.floorTitle}}</div>
      <a v-if="floorData.isMore === '0'" class="more" :href="!$isIframe ? floorData.moreUrl: 'javascript:void(0);'">
        <span>更多</span>
        <img src="@/assets/img/arrow-right.png" />
      </a>
    </div>
    <div class="content">
      <template v-if="showData.length > 0">
        <div v-for="(item, idx) in showData" :key="idx" class="box-item" @click="$jumpToPage(item)" >
            <div class="titles">
                <span class="first">{{item.title}}</span>
                <span v-if="item.subtitleFirst" class="second">{{item.subtitleFirst.length > 6 ? `${item.subtitleFirst.substr(0, 6)}...` : item.subtitleFirst}}</span>
            </div>
            <img class="img" :src="item.imageUrl" />
        </div>
    </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DivideTwo',
  props: ['floorData'],
  computed: {
    showData () {
      return this.floorData.data.length > 0 ? this.floorData.data.slice(0, 2) : []
    }
  },
  methods: {
    gotoUrl (item) {
      if (item.titleUrl) {
        location.href = item.titleUrl
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .divide-two{
    padding: 0 .1rem;
    .content{
      display: flex;
      justify-content: space-between;
      height: .83rem;
      box-sizing: border-box;
      padding: .15rem 0;
      background-color: #FFFFFF;
      .box-item{
        width: 50%;
        box-sizing: border-box;
        padding: .05rem 0.1rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .titles{
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .first{
                height: .2rem;
                line-height:.2rem;
                font-size: .14rem;
                font-family: PingFangSC, PingFangSC-Medium;
                font-weight: 500;
                color: #333333;
                text-align: left;
            }
            .second{
                font-size: .12rem;
                font-family: PingFangSC, PingFangSC-Regular;
                color: #999999;
                margin-top: .05rem;
                text-align: left;
            }
        }
        .img{
            width: .37rem;
            height: .37rem;
            border-radius: 4px;
        }
      }
      .box-item:first-child{
          border-right: 1px solid #eeeeee;
      }
    }
  }
</style>
